import React from "react";

export default function Button({ icon, callback = () => {}, text = "text",isActive=false }) {
  return (
    <div onClick={callback} className={`button ${isActive && "active"}`}>
      <div>
        <img src={icon} />
      </div>
      <div>{text}</div>
    </div>
  );
}
